<div
  class="wrapper"
  [style]="wrapperStyle"
>
  @if (shouldShowTable()) {
    <div class="table-wrapper">
      @if (isNeedGroups) {
        <div
          class="table-group-header"
          app-table-group-header
          [isAnyTableActionAvailable]="isAnyTableActionAvailable"
          [resourceParamsKey]="resourceParams.key"
        ></div>
      }
      <app-table-header
        class="table-header"
        [isNeedGroups]="isNeedGroups"
        [tableActions]="tableActions"
        [currentKeySortParam]="currentKeySortParam"
        [currentSortOrder]="currentSortOrder"
        [resourceParamsKey]="resourceParams.key"
        [isResizeColumn]="isResizeColumn"
        [isAnyTableActionAvailable]="isAnyTableActionAvailable"
        [noEmptyTableData]="!!tableData?.content?.length"
        (sortParamsChanged)="handleSortingChange($event)"
      />

      <app-table-body
        #tableBody
        class="table-body"
        [currentTableZoom]="currentTableZoom"
        [isAddNewRecordStateActive]="isAddNewRecordStateActive"
        [tableData]="tableData"
        [isEditModeActive]="isEditModeActive"
        [tableActions]="tableActions"
        [resourceParams]="resourceParams"
        [isAnyTableActionAvailable]="isAnyTableActionAvailable"
        [isNeedGroups]="isNeedGroups"
        (recordUpdated)="handleRecordUpdate($event)"
        (reloadTableData)="handleReloadTableData()"
        (recordDeleted)="handleRecordDelete($event)"
        (handleNewRecord)="handleSetNewRecordData($event)"
      />

      @if (tableTotals.length) {
        <app-table-footer
          class="table-footer"
          [tableTotals]="tableTotals"
          [tableActions]="tableActions"
          [resourceParamsKey]="resourceParams.key"
          [isAnyTableActionAvailable]="isAnyTableActionAvailable"
        />
      }
    </div>
  }
</div>
